import { render, staticRenderFns } from "./AdditionalWork.vue?vue&type=template&id=207c58d0&scoped=true"
import script from "./AdditionalWork.vue?vue&type=script&lang=js"
export * from "./AdditionalWork.vue?vue&type=script&lang=js"
import style0 from "./AdditionalWork.vue?vue&type=style&index=0&id=207c58d0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "207c58d0",
  null
  
)

export default component.exports